import { render, staticRenderFns } from "./industry-tools.vue?vue&type=template&id=5d4b4e32&scoped=true"
import script from "./industry-tools.vue?vue&type=script&lang=js"
export * from "./industry-tools.vue?vue&type=script&lang=js"
import style0 from "./industry-tools.vue?vue&type=style&index=0&id=5d4b4e32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4b4e32",
  null
  
)

export default component.exports